import React, { useEffect, useState } from "react";
import CategoryComponent from "../../components/HeaderBox";
import "./index.css";
import inventoryIcon from "../../../../../assets/design-revamp-company/company-detail-headers/inventory-icon.svg";
import { useTranslation } from "react-i18next";
import { getInventory } from "../../../../../apis/Business/InventoryApi";
import handleToFixedNum from "../../components/HeaderBox/handleToFixedNum";
import formatDate from "../../components/HeaderBox/formatDate";
import inventoryGraphic1 from "../../../../../assets/design-revamp-company/company-detail-headers/water-graphic-icon-1.svg";
import inventoryGraphic2 from "../../../../../assets/design-revamp-company/company-detail-headers/water-graphic-icon-2.svg";

const InventoryIcon = () => (
  <img
    src={inventoryIcon}
    alt="Transport Delivery Icon"
    width={76}
    height={76}
  />
);

const InventoryHeader = ({
  className,
  leftBoxProps,
  rightBoxProps,
  businessId,
  show,
  ...props
}) => {
  const { t } = useTranslation();
  const [totalObjInventory, setTotalObjInventory] = useState([]);
  useEffect(() => {
    getInventory({
      businessId: businessId,
      setTotalObj: setTotalObjInventory,
    });
  }, [businessId]);

  return (
    <CategoryComponent
      show={show}
      className={`inventory-category ${className || ""}`}
      noSystemBoundary
      leftBoxProps={{
        icon: <InventoryIcon />,
        title: t("INVENTORY"),
        description: t("INVENTORY_INTRO"),
        scopes: [{ scope: t("INVENTORY_SCOPE"), filled: true }],
        graphicIcons: [
          { icon: inventoryGraphic1 },
          { icon: inventoryGraphic2 },
        ],
        ...leftBoxProps,
      }}
      rightBoxProps={{
        totals: [
          {
            title: t("TOTAL_CATEGORY"),
            items: [
              {
                subtitle: t("EXPENSES"),
                subitems: [
                  {
                    label: "DKK",
                    value: handleToFixedNum(
                      totalObjInventory,
                      totalObjInventory?.total_expenses
                    ),
                  },
                ],
              },
              {
                subtitle: `${t("EMISSIONS")} (tCO₂e)`,
                subitems: [
                  {
                    value: handleToFixedNum(
                      totalObjInventory,
                      totalObjInventory?.total_emissions
                    ),
                  },
                ],
              },
            ],
          },
        ],
        lastUpdated: totalObjInventory?.updated_at
          ? formatDate(totalObjInventory?.updated_at)
          : t("DD_MM_YYYY"),
        ...rightBoxProps,
      }}
      {...props}
    />
  );
};

export default InventoryHeader;
